import script from "./CustomQaStatus.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomQaStatus.vue?vue&type=script&lang=ts&setup=true"

import "./CustomQaStatus.vue?vue&type=style&index=0&id=474d320f&lang=scss&scoped=true"
import "./CustomQaStatus.vue?vue&type=style&index=1&id=474d320f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-474d320f"]])

export default __exports__